import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { ExternalLink } from "lucide-react";
import { partners } from "@/data/partners";

const Partnernetzwerk = () => (
  <>
    <SEOHead title="Unser Partnernetzwerk – Leadership Focus" description="Das Partnernetzwerk von Leadership Focus. Gemeinsam stark für nachhaltige Führungsentwicklung." canonical="https://leadership-focus.de/partnernetzwerk" />
    <Header />
    <main className="py-20 min-h-[60vh]">
      <div className="container mb-10">
        <h1 className="text-4xl font-serif font-bold text-foreground mb-4">Unser Partnernetzwerk</h1>
        <p className="text-muted-foreground max-w-2xl">Gemeinsam stark – unsere Partner für nachhaltige Führungsentwicklung.</p>
      </div>
      <div className="container">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className={`group flex min-h-[180px] items-center gap-4 overflow-hidden rounded-lg border p-6 shadow-sm transition-shadow hover:shadow-md ${partner.dark ? "border-foreground/20 bg-foreground" : "bg-card text-card-foreground"}`}
            >
              <div className="min-w-0 flex-1">
                <h2 className={`mb-2 break-words hyphens-auto font-serif text-xl font-semibold ${partner.dark ? "text-primary-foreground" : "text-foreground"}`}>
                  {partner.name}
                </h2>
                <p className={`text-sm ${partner.dark ? "text-primary-foreground/70" : "text-muted-foreground"}`}>{partner.branche}</p>
                {partner.url && (
                  <a
                    href={partner.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
                  >
                    Website besuchen <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                )}
              </div>
              {partner.logo &&
                (() => {
                  const logo = (
                    <img
                      src={partner.logo}
                      alt={`${partner.name} Logo`}
                      loading="lazy"
                      className={partner.logoClass ?? "h-14 w-auto max-w-[108px] shrink-0 object-contain"}
                    />
                  );
                  return partner.url ? (
                    <a
                      href={partner.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Zur Website von ${partner.name}`}
                      className="shrink-0 self-center rounded transition-transform duration-200 hover:scale-[1.04] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                    >
                      {logo}
                    </a>
                  ) : (
                    logo
                  );
                })()}
            </div>
          ))}
        </div>
      </div>
    </main>
    <Footer />
  </>
);

export default Partnernetzwerk;
